const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnelLvl1Disable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 344.23 91.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.17,78.51c-27.8,11.87-233.5,12.09-261.24,0l-38.56-63s84.38,11.15,167.9,11.15c80.67,0,167.59-11,167.59-11Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.88,4.1C71.58,4.1,4.37,15.49,4.37,15.49A1308.33,1308.33,0,0,0,172.6,26.79c86.3,0,167.26-11.15,167.26-11.15S264.69,4.1,171.88,4.1Z",
    style: {
      fill: "#22356b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.17,78.51c-27.8,11.87-233.5,12.09-261.24,0l-38.56-63s84.38,11.15,167.9,11.15c80.67,0,167.59-11,167.59-11Z",
    style: {
      fill: "#004996"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "95.3 86.82 58.04 85.22 23.51 15.83 72.56 18.32 95.3 86.82",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.55 86.82 314.34 80.89 352.43 13.4 279.28 18.32 256.55 86.82",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelLvl1Disable);
export default __webpack_public_path__ + "static/media/funnel-lvl1-disable.e4b5e9a144c1d07638e8694ebb21771b.svg";
export { ForwardRef as ReactComponent };